import React from 'react';
import moment from "moment-timezone";
import DateRangePicker from './date-range-picker';
import {CSVDownload, CSVLink} from "react-csv";
import Parse from "parse";
import Api from "../../Utils/api";
import Utils from "../../Utils/Utility";
import LinearProgress from 'material-ui/LinearProgress';
import CONFIG_HELPER from './../../../ConfigHelper';


const headerColumns = [
    {key: 'locationName', label: 'Location'},
    {key: 'orderNum', label: 'Order No'},
    {key: 'name', label: 'Name'},
    {key: 'userType', label: 'User Type'},
    {key: 'paymentType', label: 'Payment'},
    {key: 'createdAt', label: 'Placed'},
    {key: 'scheduledAt', label: 'Scheduled'},
    {key: 'orderType', label: 'Order Type'},
    {key: 'orderState', label: 'Order Status'},
    {key: 'itemsToPrep', label: 'Item Count'},
    {key: 'subTotal', label: 'Sub-Total'},
    {key: 'discountAmount', label: 'Discount'},
    {key: 'deliveryFee', label: 'Delivery Fee'},
    {key: 'taxes', label: 'Taxes'},
    {key: 'tipAmount', label: 'Tip'},
    {key: 'platformCharge', label: 'Platform Charge'},
    {key: 'customCharge', label: 'Custom Charge'},
    // {key: 'charge2', label: 'Charge 2'},
    // {key: 'charge3', label: 'Charge 3'},
    {key: 'totalAmount', label: 'Total'},
    {key: 'stripeFee', label: 'Stripe Fee'},
    {key: 'netTotalStripFee', label: 'Net (Total - StripeFee)'}
    ];

export default class ExportOrder extends React.Component {

    // contextTypes is used to pushed the routes in url
    static contextTypes = {
        router : React.PropTypes.object.isRequired
    }

    constructor(props) {
        super(props);

        this.state = {
            fromDate       : this.setLocationTimeZoneInMoment(),
            toDate         : this.setLocationTimeZoneInMoment(),
            timeZone       : '',
            downloadCSVFile: false,
            autoDownloadCSVFile: false,
            activeLocation : null,
            orderReportsData: [],
            limit          : CONFIG_HELPER.DEFAULT_EXPORT_ORDER_LIMIT,
            skip           : 0,
            defaultScreenOrderReport: true,
            progressBar    : false,
            CSVfileName    : "",
            errorMessage   : false,
        };

        this._bind(
            'initializeDateTime',
            'onDateSelectionChanged',
            'getOrderReportData',
            'exportOrderReport',
            'showDefaultScreen',
            'fetchAndParseOrder',
            'setLocationTimeZoneInMoment'
        );
    }

    _bind(...methods) {
        methods.forEach((method) => this[method] = this[method].bind(this));
    }

    /*  Set default timezone on moment  */
    setLocationTimeZoneInMoment(){

        let timeZone = Utils.extractTimeZoneFromLocation(this.props.activeLocation);
        moment.tz.setDefault(timeZone);

        console.log(moment());
        return moment();
    }

    initializeDateTime(){

        let self = this;

        let timeZone = this.state.timeZone;

        let currentDateTime = Utils.formatDateTimeWithTimeZone(new Date(), timeZone);

        let defaultFromDate = new Date(currentDateTime);
        let defaultToDate = new Date(currentDateTime);

        defaultFromDate.setDate(defaultFromDate.getDate() - 6);
        defaultFromDate.setHours(0, 0, 0, 0);

        defaultToDate.setHours(23, 59, 59, 0);

        this.setState({
            fromDate       : defaultFromDate,
            toDate         : defaultToDate,
            orderReportsData: [],
        });

    }

    componentDidMount() {
        let self = this;
        self.initializeDateTime();
    }

    // progress(totalCount, completed) {
    //
    //     if (completed && completed >= 100) {
    //         this.setState({completed: 100});
    //     } else if (completed !=null){
    //         this.setState({completed: completed});
    //     }else {
    //         let skip = this.state.skip;
    //         let limit = this.state.limit;
    //         let completedPer = Utils.round(((skip + limit) * 100) / totalCount,2);
    //
    //         this.setState({completed: completedPer});
    //     }
    // }

    componentWillMount() {

        let timeZone = Utils.extractTimeZoneFromLocation(this.props.activeLocation);

        this.setState({
            activeLocation: this.props.activeLocation,
            timeZone: timeZone,
            CSVfileName: this.props.activeLocation.name ? (this.props.activeLocation.name).replace(/[\. ,:-]+/g, "-") : "download-csv"
        });

    }

    componentWillReceiveProps(nextProps) {
        let currentActiveLoc = this.props.activeLocation;
        let locId = "";

        if (currentActiveLoc) {
            locId = currentActiveLoc.objectId;
        }

        if (nextProps !== null
            &&
            nextProps.activeLocation !== null
            &&
            nextProps.activeLocation.objectId !== locId
        ) {
            this.setState({
                    activeLocation: nextProps.activeLocation,
                    timeZone: Utils.extractTimeZoneFromLocation(nextProps.activeLocation)
                },()=>{
                this.initializeDateTime();
            });
        }

    }

    onDateSelectionChanged(fromDate, toDate) {

        this.setState({
            fromDate:fromDate,
            toDate:toDate,
            downloadCSVFile:false
        });
    }

    async fetchAndParseOrder() {

        let skip = this.state.skip;
        let limit = this.state.limit;

        // call the api and fetch all the order records
        let orderResponseData = await this.getOrderReportData(skip);

        // parse the data
        let parseOrderDataResponse = await this.parseOrderData(orderResponseData);

        if (parseOrderDataResponse.error == false) {
            if (this.state.orderReportsData.length < parseOrderDataResponse.data.totalCount) {

                // update progress bar
                // this.progress(parseOrderDataResponse.data.totalCount,null);

                // increase the skip count
                this.setState({
                    skip: skip + limit
                });
                this.fetchAndParseOrder();

            } else if (this.state.orderReportsData.length == parseOrderDataResponse.data.totalCount) {

                this.calculateOrderReportTotal();

                // completed progress bar
                // this.progress(parseOrderDataResponse.data.totalCount,100);

                this.setState({
                    progressBar: false,
                    autoDownloadCSVFile: true,
                    downloadCSVFile: true
                })
            }
        } else {
            this.setState({
                progressBar: false,
                errorMessage: true
            })
        }
    }


    async exportOrderReport() {

        this.setState({
            defaultScreenOrderReport: false,
            progressBar: true
        });

        // this.progress(0,10);

        let responseData = await this.fetchAndParseOrder();

    }

    calculateOrderReportTotal() {

        // get the orderReportData
        var orderReportsData = this.state.orderReportsData;

        // add all the key which we want to calculate the sum
        let keyOrderReport = ['subTotal', 'discountAmount', 'deliveryFee', 'taxes', 'tipAmount', 'platformCharge','totalAmount', 'stripeFee', 'netTotalStripFee'];

        let TotalRowData = {};
        TotalRowData['locationName'] = "TOTAL";

        keyOrderReport.forEach(keyName => {

            let keyNameSum = Utils.toRoundStr(Utils.sumProperty(orderReportsData, keyName), 2);
            TotalRowData[keyName] = keyNameSum;
        });

        // push the empty row
        let emptyRow = {};
        this.state.orderReportsData.push(emptyRow);

        // push total count data
        this.state.orderReportsData.push(TotalRowData);

        // console.log(JSON.stringify(this.state.orderReportsData));
    }
    getOrderReportData(skip) {
        let self = this;
        let currentUser = Parse.User.current();
        let userId = currentUser.id;
        let sessionToken = currentUser.getSessionToken();
        let locId = this.state.activeLocation.objectId;

        const businessDetail = currentUser.get("bizId");
        const bizId          = businessDetail.id;

        let fromDate = this.state.fromDate;
        let toDate = this.state.toDate;
        let limit = this.state.limit;
        // let skip = this.state.skip;

        // let fromDateTime =  moment(fromDate).format('YYYY-MM-DD');
        // let toDateTime =  moment(toDate).format('YYYY-MM-DD');

        let fromDateTime =  Utils.getDateString(fromDate, this.state.timeZone);
        let toDateTime =  Utils.getDateString(toDate, this.state.timeZone);

        const dateRange = {'tzStartDate': fromDateTime, 'tzEndDate': toDateTime};

        return Api.getOrdersAt(
            userId, sessionToken, dateRange, locId, limit, bizId, skip
        ).then((response) => {
                return response;
            },
            (error) => {

                // console.log("Error while fetching Order details !" + JSON.stringify(error));
                // user session is invalid
                Utils.checkErrorIsInvalidSessionToken(error, self.context.router);
            }
        ).then((responseData) => responseData);

    }

     parseOrderData(orderResponseData){
         let timeZone = this.state.activeLocation.timeZone;
         if (orderResponseData.data && orderResponseData.data.length > 0) {

            const results = orderResponseData.data;

            results.forEach(result => {

                /* Response Data*/
                let newTable = {};

                // fetch all the columns and add logic
                headerColumns.map((rowVal, key) => {

                    // get key
                    let col = rowVal.key;

                    if (col == "locationName") {
                        newTable[col] = (this.state.activeLocation.name).toString();
                    } else if (col == "createdAt") {
                        // let createdAt = moment(result[col]);
                        // let formattedDate = createdAt.format("MMM Do YYYY, h:mm:ss a");
                        let createdAt = new Date(result[col]);
                        // let formattedDate = createdAt.format("MMM Do YYYY, h:mm:ss a");
                        let  formattedDate = Utils.formatDateTimeWithTimeZone(createdAt,timeZone);
                        newTable[col] = formattedDate;
                    } else if (col == "scheduledAt") {
                        // check if schedule date exist or not
                        if (result[col] && result[col].iso) {
                            // let scheduledAt = moment(result[col].iso);
                            // let scheduledAtFormattedDate = scheduledAt.format("MMM Do YYYY, h:mm:ss a");
                            let scheduledAt = new Date(result[col].iso);
                            let  scheduledAtFormattedDate = Utils.formatDateTimeWithTimeZone(scheduledAt,timeZone);
                            newTable[col] = scheduledAtFormattedDate;
                        } else {
                            newTable[col] = null;
                        }
                    } else if (col == "name") {
                        let name = result["userInfo"].name;
                        newTable[col] = name;
                    } else if (col == "userType") {
                        let user = null;
                        let userInfo = result["userInfo"];

                        if (!Utils.isEmptyObj(userInfo) && userInfo.hasOwnProperty("userType") && userInfo.userType == "guest") {
                            user = "Guest User"
                        }

                        newTable[col] = user;
                    } else if (col == "phone") {
                        let phone = result["userInfo"].phone;
                        newTable[col] = phone;
                    } else if (col == "discountAmount") {
                        let discount = result["couponInfo"].discountAmount ? Utils.number2digit(result["couponInfo"].discountAmount) : null;
                        newTable[col] = discount;
                    } else if (col == "customCharge") {
                        if (!Utils.isEmptyObj(result["charge"])) {
                            let customCharge = result["charge"];

                            let chargeData = "";
                            customCharge.map((ch, index, array) => {
                                chargeData += ch.tag + ": $" + ch.fee+",";
                            });

                            newTable[col] = chargeData
                        } else {
                            newTable[col] = null;
                        }
                    }
                        // else if (col == "charge2") {
                        //
                        //     let charge2 = null;
                        //     if (!Utils.isEmptyObj(result["charge2"])){
                        //         let charge2Obj = result["charge2"];
                        //         charge2 = charge2Obj.fee ? Utils.number2digit(charge2Obj.fee) : null;
                        //     }
                        //     newTable[col] = charge2;
                        //
                        // }
                        // else if (col == "charge3") {
                        //
                        //     let charge3 = null;
                        //     if (!Utils.isEmptyObj(result["charge3"])){
                        //         let charge3Obj = result["charge3"];
                        //         charge3 = charge3Obj.fee ? Utils.number2digit(charge3Obj.fee) : null;
                        //     }
                        //     newTable[col] = charge3;
                        //
                    // }
                    else if (col == "stripeFee") {
                        let totalAmount = result["totalAmount"];
                        newTable[col] = "-"+Utils.calculateStripeFee(totalAmount);
                    }else if (col == "netTotalStripFee") {
                        let totalAmount = result["totalAmount"];
                        newTable[col] = Utils.calculateNetTotalStripeFee(totalAmount);
                    }else if (col == "orderType") {
                        newTable[col] = Utils.getOrderTypeStr(result);
                    } else {
                        newTable[col] = result[col];
                    }

                });

                this.state.orderReportsData.push(newTable);

            });
            const responseData = {
                error: false,
                Message: "Success",
                data: {
                    totalCount: orderResponseData.count
                }
            };
            return responseData
        }
        else {
            const responseData = {
                error: true,
                Message: "No data found",
                data: {}

            };
            return responseData
        }
    }

    showDefaultScreen(){

        let timeZone = this.state.timeZone;

        let currentDateTime = Utils.formatDateTimeWithTimeZone(new Date(), timeZone);

        let currentTime = new Date(currentDateTime);

        let fromDateObj = {year: currentTime.getFullYear(), month: currentTime.getMonth(), day: currentTime.getDate()};

        let defaultFromDate = moment(fromDateObj);
        // let defaultToDate = moment(toDateObj);

        let fromDate = defaultFromDate.subtract(6, 'days').toDate();

        this.setState({
            fromDate: fromDate,
            toDate: currentTime,
            progressBar: false,
            errorMessage: false,
            defaultScreenOrderReport: true,
            downloadCSVFile: false,
            autoDownloadCSVFile: false,
        })
    }

    render() {

        // get the orderReportData and header
        const csvData = this.state.orderReportsData;
        const headers = headerColumns;

        return (
            <div className="section export-order-container">
                <div className="container" style={{maxWidth: '100%'}}>
                    {
                        this.state.defaultScreenOrderReport ?
                            <div>
                                <h4 className="mt-30">Select start & end date to download the order report.</h4>
                                <h4 style={{color:"#2b2d2f"}}>Maximum date range is 18 months.</h4>
                                <div className="mb-10">
                                    <DateRangePicker
                                        defaultDateRangeDays={"547"}
                                        startDefaultFromDays={"6"}
                                        allowMinPastYear={"2"}
                                        timeZone = {this.state.timeZone}
                                        callBackParent={this.onDateSelectionChanged}/>

                                    <hr/>
                                </div>

                                <div className={"export-button mb-30"}>
                                <button className={"btn btn-danger"}
                                        onClick={this.props.closeCallback}
                                        style={{marginRight: '5px'}}>Cancel
                                </button>
                                <button className={"btn btn-primary"}
                                        onClick={this.exportOrderReport}
                                        style={{marginLeft: '5px'}}>Export as CSV
                                </button>
                                </div>
                            </div> : null
                    }
                    {
                        this.state.progressBar ?
                            <div>
                                <h4>Exporting order reports...</h4>
                                <LinearProgress color={"blue"} />

                            </div> : null
                    }
                    {
                        this.state.errorMessage ?
                            <div className={"export-download-container"}>
                                <h4>No search data found<br/><br/>
                                    {Utils.getDateString(this.state.fromDate, this.state.timeZone)} to {Utils.getDateString(this.state.toDate, this.state.timeZone)}
                                    <br/>
                                    <br/>
                                    <button className={"btn btn-link"}
                                            onClick={this.showDefaultScreen}
                                    >Try again
                                    </button>
                                </h4>
                            </div> : null
                    }
                    {
                        this.state.autoDownloadCSVFile ?
                            <CSVDownload data={csvData} filename={this.state.CSVfileName+".csv"}  headers={headers} /> : null
                    }
                    {
                        this.state.downloadCSVFile ?
                            <div className={"export-download-container"}>Your export is ready. If you don't see your file,
                                <CSVLink data={csvData}
                                         filename={this.state.CSVfileName+".csv"}
                                         className="btn btn-link"
                                         headers={headers}>You can try downloading it again.
                                </CSVLink>
                            </div>
                            : null
                    }

                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// src/components/visualization/export-order.jsx